import { useEffect } from 'react';

/**
 * Set the browser tab title for the duration of the mounting component.
 * On unmount we restore the prior title — useful when a deeper layout
 * (e.g. Mirror) wants to override a generic Mission Control title.
 *
 * Conventions used across the app:
 *   Mission Control · {Page}   ·  Seertech
 *   Mirror          · {Page}   ·  Seertech
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
